import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Semantic level driving the color palette. "disclosure" is neutral with no background and no padding; "info" is informational blue; "warning" is cautionary yellow; "alert" is destructive red.
   *
   * @type {String}
   * @default "info"
   * @values disclosure, info, warning, alert
   * @storybook-control select
   */
  level: {
    type: String,
    default: "info",
    validator: (value) => ["disclosure", "info", "warning", "alert"].includes(value),
  },
  /**
   * Visual layout variant. "default" applies the standard padding; "card" is the padded box used for notices inside content, such as search results, rounded where the theme sets its corner radius; "full" spans the page and keeps its text in a centered column capped at 1170px, 1280px from a 1440px-wide window.
   *
   * @type {String}
   * @default "default"
   * @values default, card, full
   * @storybook-control select
   */
  variant: {
    type: String,
    default: "default",
    validator: (value) => ["default", "card", "full"].includes(value),
  },
  /**
   * Name of an sp-icon glyph drawn before the first line of text. Leave empty or set to "none-filled" to omit the icon.
   *
   * @type {String}
   * @default undefined
   */
  icon: {
    type: String,
    default: undefined,
  },
  /**
   * Collapse the body behind the title. The title becomes a button that shows and hides the body below it. A broadcast without a title is never collapsed.
   *
   * @type {Boolean|String}
   * @default false
   */
  collapsable: booleanAttribute(),
  /**
   * Render a close button at the end of the first line. Clicking it hides the broadcast in place.
   *
   * @type {Boolean|String}
   * @default false
   */
  dismissable: booleanAttribute(),
  /**
   * Run the title into the body text, separated by a space, instead of giving it a line of its own. Ignored when the broadcast collapses.
   *
   * @type {Boolean|String}
   * @default false
   */
  inline: booleanAttribute(),
});
